/**
 * Class with general functions, used in the whole project
 * @author Michel Heitbirnk
 */
import $ from 'jquery';
import ServerRequest from './ServerRequest';

class Context {

    constructor( options ) {
        this.rqst = new ServerRequest( options );
    }

    /**
     * Does a XHR request with the given options
     * @param  {Object} options
     */
    call(options) {

        console.warn('DEPRECATED: use the class ServerRequest instead of Context.call');

        if ( options.method ){

            var callOptions = {};

            if ( options.url ) {
                callOptions.url = options.url;
            }

            if ( !options.type ){
                options.type = 'POST';
            }

            this.rqst.call( options.type.toUpperCase() , options.method , options.params, callOptions ).then( ( { result, status, message } ) => {

                if ( typeof options.onSuccess === 'function' ) {
                    options.onSuccess.apply(this, [result, message]);
                }

            }).catch( ({ status, message } ) => {

                if ( typeof options.onError === 'function' ) {
                    options.onError.apply(this, [status, message]);
                }

            })
        }
        else {
            throw 'No method defined';
        }
    }

    /**
     * Submits Form with a XHR request.
     * @param  {Object} option
     */
    submit(options) {

        console.warn('DEPRECATED: use the class ServerRequest instead of Context.submit');

        if ( options.method && options.form ){

            const form = document.querySelector(options.form);

            if ( form ) {

                const $form = $(form);
                var valid = true;

                /**
                 * Validate given form if Abide is assigned to the form
                 */
                if ( options && !options.skipValidation ) {

                    if ( $form.data('abideClass') !== null ){
                        valid = $form.foundation('validateForm');
                    }

                }

                /**
                 * Submit form if the form is valid
                 */
                if ( valid )  {

                    /**
                     * Format the form data to correct peanuts data
                     */
                    var formattedData = this.formatPostData($form);

                    /**
                     * Trigger the callback 'beforeSubmit' if defined
                     */
                    if ( typeof options.beforeSubmit === 'function'){

                        var processedOptions = options.beforeSubmit.apply(this, [formattedData]);

                        if ( typeof processedOptions !== 'undefined' && processedOptions !== null){
                            formattedData = processedOptions;
                        }
                    }

                    /**
                     * Add given params to the call
                     */
                    options.params = Object.assign(formattedData, options.params);

                    /**
                     * Send call with XHR request
                     */
                    this.call(options);
                }
                else {

                    if ( typeof options.onValidationError === 'function' ){
                        options.onValidationError.apply(this);
                    }
                }
            }
            else {
                throw 'Form not found';
            }
        }
        else {
            throw 'No method defined';
        }
    }

    /**
     * Formats form data to peanuts format
     *
     * @param  {jQuery} $form
     * @return {Object}
     */
    formatPostData($form) {

        var formdata = $form.serializeArray(),
            formattedData = {},
            match = null;

        formdata.forEach( (param) => {

            var key = param.name,
                value = param.value;

            if( key.indexOf('[') > -1 ){
                var keys = key.replace(/[\]]+/g, '').split('[');

                if ( keys.length === 2 ) {

                    if ( typeof keys[1] !== 'undefined' ){
                        formattedData[keys[0]] = ( formattedData[keys[0]] === undefined ) ? {} : formattedData[keys[0]];
                        formattedData[keys[0]][keys[1]] = value;
                    }
                }

                if ( keys.length === 3 ) {
                    formattedData[keys[0]] = ( formattedData[keys[0]] === undefined ) ? {} : formattedData[keys[0]];
                    formattedData[keys[0]][keys[1]] = ( formattedData[keys[0]][keys[1]] === undefined ) ? {} : formattedData[keys[0]][keys[1]];
                    formattedData[keys[0]][keys[1]][keys[2]] = value;
                }
            }
            else {
                formattedData[key] = value;
            }

        });

        return formattedData;
    }
}

export default new Context();
